import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 pt-10" }
const _hoisted_2 = { class: "item-min-height col-span-12 mb-10 xl:col-span-3 xl:mb-0" }
const _hoisted_3 = { class: "box w-full rounded-2xl py-5 pb-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-xl font-medium text-gray-500 dark:text-white" }, "Nederland", -1)
const _hoisted_5 = { class: "text-md text-center font-medium text-gray-400 dark:text-gray-500" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-gray-400 dark:text-gray-600"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "flex h-full flex-col"
}
const _hoisted_9 = {
  key: 2,
  class: "mt-5 text-center"
}
const _hoisted_10 = { class: "col-span-12 mb-10 xl:col-span-5 xl:mb-0 xl:px-10" }
const _hoisted_11 = { class: "box w-full rounded-2xl py-5 pb-7" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-xl font-medium text-gray-500 dark:text-white" }, "Voorraad", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "text-md text-center font-medium text-gray-400 dark:text-gray-500" }, "per locatie", -1)
const _hoisted_14 = {
  key: 0,
  class: "flex h-full flex-col"
}
const _hoisted_15 = { class: "mt-10" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "col-span-12 xl:col-span-4" }
const _hoisted_18 = { class: "box w-full rounded-2xl py-5 pb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-xl font-medium text-gray-500 dark:text-white" }, "Geschiedenis", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", { class: "text-md text-center font-medium text-gray-400 dark:text-gray-500" }, "~1,5 jaar", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "flex h-full flex-col"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", { class: "inline-block w-full pr-10 text-right text-xs text-gray-300 dark:text-gray-600" }, "Data from GIE AGSI / ALSI ", -1)
const _hoisted_24 = { class: "grid grid-cols-12 justify-center p-5 pb-0 pt-10" }
const _hoisted_25 = {
  key: 0,
  class: "col-span-12 flex h-24 flex-row items-center justify-center md:col-span-6 md:mr-10"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "pr-5 text-2xl text-blue" }, "Hoog", -1)
const _hoisted_27 = { class: "flex h-full flex-col items-center justify-center" }
const _hoisted_28 = { class: "text-2xl text-gray-600 dark:text-white" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, "%", -1)
const _hoisted_30 = { class: "text-lg text-gray-400" }
const _hoisted_31 = {
  key: 1,
  class: "col-span-12 flex h-24 flex-row items-center justify-center md:col-span-6"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "pr-5 text-2xl text-blue" }, "Laag", -1)
const _hoisted_33 = { class: "flex h-full flex-col items-center justify-center" }
const _hoisted_34 = { class: "text-2xl text-gray-600 dark:text-white" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, "%", -1)
const _hoisted_36 = { class: "text-lg text-gray-400" }
const _hoisted_37 = {
  key: 2,
  class: "mt-5 text-center"
}

import moment from 'moment';
import { onMounted, ref } from 'vue';
import DoughtnutChart from '@/components/charts/DoughtnutChart.vue';
import { useStorageStore, StorageResponse } from '@/stores/main';
import PieChart from '../charts/PieChart.vue';
import LineChart from '../charts/LineChart.vue';
import AppErrorMessage from '../ui/AppErrorMessage.vue';
import AppLoader from '../ui/AppLoader.vue';
import StorageDataDetails from './StorageDataDetails.vue';
import ChartDescription from '../ui/ChartDescription.vue';

const STORAGE_TYPE = 'country';


export default /*#__PURE__*/_defineComponent({
  __name: 'GasStorageCountry',
  props: {
  pieChartData: {
    type: Array
  }
},
  setup(__props) {

const store = useStorageStore();



const chartData = ref();
const storageData = ref();
const error = ref(false);
const isLoading = ref(true);
const storageDetails = ref();
const highestPrice = ref();
const lowestPrice = ref();

const getGasStorageData = async (): Promise<StorageResponse> => {
  const URL = '/.netlify/functions/getGasStorageForCountry';
  let data: any = {};

  const header = new Date().getTime();

  try {
    if (!store.hasValidStorageData(STORAGE_TYPE)) {
      const res = await fetch(URL, { headers: { 'x-time': header } });
      data = await res.json();
      store.addstorageItem({ ...data, type: STORAGE_TYPE, timestamp: Date.now() });
    } else {
      data = store.getStorageItem(STORAGE_TYPE) as StorageResponse;
    }
  } catch (err) {
    data as StorageResponse;
  }

  return data.result && data.result[0] ? data.result[0] : false;
}

const setAndFormatData = (data: any) => {
  const formattedStorageData: any = {};

  formattedStorageData.today = moment(data.data[0].gasDayStart).format('DD MMM yyyy');
  formattedStorageData.full = Math.round(data.data[0].full);
  formattedStorageData.delay = moment().diff(moment(data.data[0].gasDayStart), 'days');

  storageData.value = formattedStorageData;

  const lineChartData = [{
    data: data.data.map((item: any) => {
      return {
        x: new Date(item.gasDayStart),
        y: +item.full
      }
    })
  }];

  // get storage details
  storageDetails.value = {
    storage: data.data[0].gasInStorage,
    injection: data.data[0].injection,
    withdrawal: data.data[0].withdrawal
  }

  chartData.value = lineChartData;

  const highestPriceObj = [...data.data].sort((a, b) => b.full - a.full);
  // eslint-disable-next-line prefer-destructuring
  highestPrice.value = highestPriceObj[0];

  const lowestPriceObj = [...data.data].sort((a, b) => a.full - b.full);
  // eslint-disable-next-line prefer-destructuring
  lowestPrice.value = lowestPriceObj[0];
}

/**
 * on mounted Vue lifecycle event
 */
onMounted(async () => {
  const result = await getGasStorageData();

  isLoading.value = false;

  if (result) {
    setAndFormatData(result);
  } else {
    error.value = true;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h4", _hoisted_5, [
          _createTextVNode(_toDisplayString(storageData.value?.today) + " ", 1),
          (storageData.value?.delay > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString(storageData.value?.delay) + " dagen vertraging)", 1))
            : _createCommentVNode("", true)
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
              _createVNode(AppLoader, { class: "mt-10" })
            ]))
          : _createCommentVNode("", true),
        (!isLoading.value && !error.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
              _createVNode(DoughtnutChart, {
                class: "my-10",
                value: storageData.value?.full,
                color: 'gray'
              }, null, 8, ["value"]),
              _createVNode(StorageDataDetails, {
                class: "mb-7",
                storage: storageDetails.value.storage,
                withdrawal: storageDetails.value.withdrawal,
                injection: storageDetails.value.injection,
                color: "green"
              }, null, 8, ["storage", "withdrawal", "injection"]),
              _createVNode(ChartDescription, { class: "mt-5 xl:mt-auto xl:pb-12" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Deze diagram geeft de totale voorraad gas in Nederland weer. ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (error.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
              _createVNode(AppErrorMessage)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        (__props.pieChartData?.length === 6)
          ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
              _createElementVNode("section", _hoisted_15, [
                _createVNode(PieChart, {
                  class: "mt-16",
                  chartData: __props.pieChartData
                }, null, 8, ["chartData"])
              ]),
              _createVNode(ChartDescription, { class: "mt-5 px-20 xl:mt-auto xl:pb-12" }, {
                default: _withCtx(() => [
                  _createTextVNode("De taartdiagram geeft het totale gasvoorraad per locatie aan van de Nederlandse markt op dit moment.")
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_16, [
              _createVNode(AppLoader, { class: "mt-10" })
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
              _createVNode(AppLoader, { class: "mt-10" })
            ]))
          : _createCommentVNode("", true),
        (!error.value && !isLoading.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
              (chartData.value.length)
                ? (_openBlock(), _createBlock(LineChart, {
                    key: 0,
                    class: "mt-16",
                    chartData: chartData.value,
                    height: 260,
                    yAxisTitle: '% vol',
                    subTitle: 'Geschiedenis van de laatste ~8 maanden'
                  }, null, 8, ["chartData"]))
                : _createCommentVNode("", true),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                (highestPrice.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("h4", _hoisted_28, [
                          _createTextVNode(_toDisplayString(highestPrice.value.full) + " ", 1),
                          _hoisted_29
                        ]),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(moment)(highestPrice.value.gasDayStart).format("DD MMM YYYY")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (lowestPrice.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("h4", _hoisted_34, [
                          _createTextVNode(_toDisplayString(lowestPrice.value.full) + " ", 1),
                          _hoisted_35
                        ]),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(moment)(lowestPrice.value.gasDayStart).format("DD MMM YYYY")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(ChartDescription, { class: "mt-[58px] px-10" }, {
                default: _withCtx(() => [
                  _createTextVNode("De grafiek geeft het gasvoorraad per gasdag aan van de Nederlandse markt van de laatste 1,5 jaar.")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (error.value && !isLoading.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
              _createVNode(AppErrorMessage)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})